import { Table, TableContainer, TableHead, TableRow } from "@mui/material";
import React from "react";
import { DataTableProps } from "../../types/DataTableProps";
import { antiFlashWhite } from "../../utils/StyleHelpers";

const DataTable = ({
  tableHeader,
  tableBody,
  minWidth,
  label,
  size,
  id,
}: DataTableProps) => (
  <TableContainer
    style={{
      border: "1px solid #C7C7C7",
      borderRadius: "0.5rem",
      // overflowX: 'hidden',
      maxHeight: "763px",
    }}
    id={id ?? "st-datatable"}
  >
    <Table stickyHeader size={size ? size : "medium"} aria-label={label}>
      <TableHead style={{ backgroundColor: antiFlashWhite }}>
        <TableRow style={{ backgroundColor: antiFlashWhite }}>
          {tableHeader}
        </TableRow>
      </TableHead>
      {tableBody}
    </Table>
  </TableContainer>
);

export default DataTable;
